import { useState, useCallback } from 'react';
import { requestLocationPermission } from 'src/utils';

export default function useCurrentCoords() {
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCoords = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await requestLocationPermission(); 
      setCoords(result);
      setError(null);
      return result; 
    } catch (err) {
      console.warn('useCurrentCoords: failed to get location', err);
      setError(err.message || 'Location permission denied or unavailable');
      setCoords(null);
      throw err; 
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    coords,       
    loading,        
    error,           
    fetchCoords,      
  };
}